import { Injectable, inject } from '@angular/core';
import { appInsights } from '@ao/app/app.config';
import { UserManagementService } from '@ao/app/shared/services/user-management.service';
import { MsalService } from '@azure/msal-angular';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private msalService = inject(MsalService);
  private userManagementService = inject(UserManagementService);
  private secureStorage = inject(SecureStorageService);
  public async logout() {
    await this.userManagementService.updateLoginStatus(false).toPromise();
    this.secureStorage.clear();
    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();
    await this.clearCache();
    appInsights.clearAuthenticatedUserContext();

    this.msalService.logoutRedirect();
  }

  private clearCookies() {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name =
        eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

      // Log the cookie being cleared for monitoring purposes
      console.log(`Clearing cookie: ${name}`);
      // Clear the cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
    }
  }

  private async clearCache() {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
  }
}
